module.exports = __webpack_public_path__ + "dm.svg?b080dd1470a2faaee75248865fa7bd58";